export const globalTitle = 'Explore Pickleball Leagues | Local, National & Professional Leagues';
export const globalDescription =
  'Discover top-tier pickleball leagues in the USA, Canada and globally featuring national and professional events, pickleball schedules, and updates.';

export type PermissionType =
  | 'IsPrimary'
  | 'CanAddTourneys'
  | 'CanAddLeagues'
  | 'CanManageClinics'
  | 'CanManageEvent'
  | 'CanManageActivities'
  | 'CanManageScores'
  | 'CanManageAttendees'
  | 'CanManageCheckin'
  | 'CanManagePayments'
  | 'CanManageReferees'
  | 'CanManageVolunteers'
  | 'CanManageLeague'
  | 'CanManageLeagueSession'
  | 'CanAddLeagueSession'
  | 'CanUploadRatings'
  | 'CanManuallyEnterRatings'
  | 'CanManagerUDF'
  | 'CanManageSanctionRequests'
  | 'CanManageLeagues';

export const mappings: { [K in PermissionType]?: PermissionType[] } = {
  CanManageActivities: ['CanManageEvent'],
  CanManageScores: ['CanManageActivities', 'CanManageEvent'],
  CanManageAttendees: ['CanManageActivities', 'CanManageEvent'],
  CanManageCheckin: ['CanManageActivities', 'CanManageEvent'],
  CanManagePayments: ['CanManageActivities', 'CanManageEvent'],
  CanManageReferees: ['CanManageEvent'],
  CanManageVolunteers: ['CanManageEvent'],
  CanManageLeague: ['CanAddLeagues'],
  CanManageLeagueSession: ['CanAddLeagueSession', 'CanManageLeague'],
  CanAddLeagueSession: ['CanManageLeague', 'CanAddLeagues'],
  CanManagerUDF: ['CanManagerUDF', 'CanManageEvent'],
  CanManageSanctionRequests: ['CanManageSanctionRequests', 'CanAddTourneys', 'CanManageEvent'],
  CanManageLeagues: ['CanManageScores', 'CanManageLeague', 'CanManageLeagueSession', 'IsPrimary'],
};
